<template>
	<div id="appraisals-index"
		 class="app-home ui-styles"
		 :class="theme">
		<spinner v-if="loading">
		</spinner>

		<template v-else>

			<side-nav-bar :filesOpen="filesOpen" :fileOpen="fileOpen" :fileId="appraisalfile.id"
						  :fileNumber="appraisalfile.number" :reportOpen="reportOpen"
						  :reportNumber="appraisalreport.number" :versionNumber="appraisalreport.version"
						  :realEstates="appraisalreport_realestates" :realEstateId="realestate.id"
						  :reportId="appraisalreport.id"></side-nav-bar>

			<div class="app-container">
				<bar>
				</bar>
				<h1>{{ $t('Edit_Appraisal') }}<span v-if="appraisal.dirty">*</span></h1>

				<div class="datedata">
					<p class="small">{{ $t('Created') }}: {{ millis_to_time(appraisal.date_created) }}</p>
					<p class="small">{{ $t('Last_modified') }}: {{ millis_to_time(appraisal.date_modified) }}</p>
				</div>

				<div class="tab_container">
					<span>hola!</span>

				</div>
				<!--
				<bar>
				</bar>
-->
			</div>

		</template>
	</div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from 'vuex'
    import _ from 'lodash'
    import moment from 'moment'
    import { dateMixin, localStorageMixin } from '../../../mixins'
    import Spinner from '../../../components/Spinner.vue'
    import Search from '../../../components/ContactsSearch/Index.vue'
    import Editor from '../../../components/Editor/Index.vue'
    import Bar from '../../../components/Bar/Index.vue'
    import IconButton from '../../../components/IconButton/Index.vue'
    import SideNavBar from '../../../components/SideNavBar/Index.vue'

    import router from '../../../router/index.js'

    import Message from '../../../components/Message.vue'


    export default {
        name: 'appraisal-container',

        mixins: [
            dateMixin, localStorageMixin
        ],

        data: () => ({
            loading: true,
            filesOpen: true,
            fileOpen: true,
            reportOpen: true,
            error: null,
            success_message: null,


        }),

        created () {

                this.loading = false

        },

        components: {
            Bar,
            Message,
            IconButton,
            Spinner,
            SideNavBar
        },

        computed: {
            ...mapGetters([
                'theme',
                'appraisal',
				'appraisalfile',
				'appraisalreport',
                'appraisalreport_realestates',
				'realestate'
            ])
        },

        methods: {
            ...mapActions(
                [

                ]),

            onGoBack: function () {
                // console.log('yeah back')
                router.go(-1)
            },
            onGoUp: function () {
                // console.log('yeah up')
                this.$router.push({name: 'realestate-editor', query: {id: this.realestate.id}})
            }
        },
        head: {
            title: {
                //inner: Vue.i18n.translate('New_contact')
                inner: 'Appraisal'
            }
        }

    }
</script>


// WEBPACK FOOTER //
// AppraisalContainer.vue?728135a6